import { render, staticRenderFns } from "./adsorption-reference-species-content.vue?vue&type=template&id=50e7da18&"
import script from "./adsorption-reference-species-content.vue?vue&type=script&lang=js&"
export * from "./adsorption-reference-species-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports